export default __webpack_public_path__ + "static/media/blank_img.08e94710.jpg";